import { render, staticRenderFns } from "./SeatingDistribution.vue?vue&type=template&id=be4ed862&scoped=true"
import script from "./SeatingDistribution.vue?vue&type=script&lang=js"
export * from "./SeatingDistribution.vue?vue&type=script&lang=js"
import style0 from "./SeatingDistribution.vue?vue&type=style&index=0&id=be4ed862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ed862",
  null
  
)

export default component.exports